module.exports = __webpack_public_path__ + "img/inktober_2020_30_ominous.8534cef5.jpg";